import { createSlice } from '@reduxjs/toolkit';
import { getPersonLinkTypesThunk } from './PersonLink.thunk';

export const personLinkSlice = createSlice({
  name: 'personLink',
  initialState: {
    types: {
      items: [],
      loading: true,
    },
    selected: {
      item: undefined,
      loading: true,
    },
  },
  reducers: {
    setSelectedPersonLinkAction: (state, action) => ({
      ...state,
      selected: {
        ...state.selected,
        item: action.payload,
      },
    }),
    resetPersonLinkTypesAction: (state, action) => ({
      ...state,
      types: {
        ...state.types,
        items: [],
      },
    }),
  },
  extraReducers: builder => {
    // Start Person link Types
    builder.addCase(getPersonLinkTypesThunk.pending, (state, action) => {
      state.types = { ...state.types, loading: true };
    });
    builder.addCase(getPersonLinkTypesThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.types = { ...state.types, items: data, loading: false };
    });
    builder.addCase(getPersonLinkTypesThunk.rejected, (state, action) => {
      // state.types = { ...state.types, loading: false };
    });
    // End Person link Types
  },
});

export const getPersonLinkTypes = (state: any) => state.personLink.types;
export const getSelectedPersonLink = (state: any) => state.personLink.selected;

export const { setSelectedPersonLinkAction } = personLinkSlice.actions;

export default personLinkSlice.reducer;
